module.exports = __webpack_public_path__ + "static/img/home_cajaseca.a3e2518.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_cajaseca.png
// module id = 77
// module chunks = 0